import icon from "@material-ui/icons/SupervisedUserCircle";

export default { icon };
